// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { DocumentFragment } from '../../../documents/graphql/DocumentFragment.generated';
import { gql } from '@apollo/client';
import { DocumentFragmentDoc } from '../../../documents/graphql/DocumentFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGenericDocumentMutationVariables = Types.Exact<{
  documentId: Types.Scalars['ID']['input'];
  documentInput: Types.UpdateDocumentInput;
  createEntityDocumentRelationshipInputs: Array<Types.CreateEntityDocumentRelationshipInput> | Types.CreateEntityDocumentRelationshipInput;
  deleteEntityDocumentRelationshipInputs: Array<Types.DeleteEntityDocumentRelationshipInput> | Types.DeleteEntityDocumentRelationshipInput;
}>;


export type UpdateGenericDocumentMutation = { __typename?: 'Mutation', deleteEntityDocumentRelationships: Array<string>, updateDocument: (
    { __typename?: 'Document' }
    & DocumentFragment
  ), createEntityDocumentRelationships: Array<{ __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, entity?: { __typename?: 'Entity', id: string } | null, document: { __typename?: 'Document', id: string } }> };

export type BulkUpdateGenericDocumentMutationVariables = Types.Exact<{
  input: Array<Types.AugmentedUpdateDocumentInput> | Types.AugmentedUpdateDocumentInput;
  createEntityDocumentRelationshipInputs: Array<Types.CreateEntityDocumentRelationshipInput> | Types.CreateEntityDocumentRelationshipInput;
  deleteEntityDocumentRelationshipInputs: Array<Types.DeleteEntityDocumentRelationshipInput> | Types.DeleteEntityDocumentRelationshipInput;
}>;


export type BulkUpdateGenericDocumentMutation = { __typename?: 'Mutation', deleteEntityDocumentRelationships: Array<string>, updateDocuments: Array<{ __typename?: 'Document', id: string, name: string, type: Types.DocumentType }>, createEntityDocumentRelationships: Array<{ __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, entity?: { __typename?: 'Entity', id: string } | null, document: { __typename?: 'Document', id: string } }> };

export const Operations = {
  Mutation: {
    UpdateGenericDocument: 'UpdateGenericDocument' as const,
    BulkUpdateGenericDocument: 'BulkUpdateGenericDocument' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateGenericDocumentDocument = gql`
    mutation UpdateGenericDocument($documentId: ID!, $documentInput: UpdateDocumentInput!, $createEntityDocumentRelationshipInputs: [CreateEntityDocumentRelationshipInput!]!, $deleteEntityDocumentRelationshipInputs: [DeleteEntityDocumentRelationshipInput!]!) {
  updateDocument(id: $documentId, input: $documentInput) {
    ...Document
  }
  createEntityDocumentRelationships(
    input: $createEntityDocumentRelationshipInputs
  ) {
    id
    entity {
      id
    }
    document {
      id
    }
    relationshipType
  }
  deleteEntityDocumentRelationships(
    input: $deleteEntityDocumentRelationshipInputs
  )
}
    ${DocumentFragmentDoc}`;
export type UpdateGenericDocumentMutationFn = Apollo.MutationFunction<UpdateGenericDocumentMutation, UpdateGenericDocumentMutationVariables>;

/**
 * __useUpdateGenericDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateGenericDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericDocumentMutation, { data, loading, error }] = useUpdateGenericDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      documentInput: // value for 'documentInput'
 *      createEntityDocumentRelationshipInputs: // value for 'createEntityDocumentRelationshipInputs'
 *      deleteEntityDocumentRelationshipInputs: // value for 'deleteEntityDocumentRelationshipInputs'
 *   },
 * });
 */
export function useUpdateGenericDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGenericDocumentMutation, UpdateGenericDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGenericDocumentMutation, UpdateGenericDocumentMutationVariables>(UpdateGenericDocumentDocument, options);
      }
export type UpdateGenericDocumentMutationHookResult = ReturnType<typeof useUpdateGenericDocumentMutation>;
export type UpdateGenericDocumentMutationResult = Apollo.MutationResult<UpdateGenericDocumentMutation>;
export type UpdateGenericDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateGenericDocumentMutation, UpdateGenericDocumentMutationVariables>;
export const BulkUpdateGenericDocumentDocument = gql`
    mutation BulkUpdateGenericDocument($input: [AugmentedUpdateDocumentInput!]!, $createEntityDocumentRelationshipInputs: [CreateEntityDocumentRelationshipInput!]!, $deleteEntityDocumentRelationshipInputs: [DeleteEntityDocumentRelationshipInput!]!) {
  updateDocuments(input: $input) {
    id
    name
    type
  }
  createEntityDocumentRelationships(
    input: $createEntityDocumentRelationshipInputs
  ) {
    id
    entity {
      id
    }
    document {
      id
    }
    relationshipType
  }
  deleteEntityDocumentRelationships(
    input: $deleteEntityDocumentRelationshipInputs
  )
}
    `;
export type BulkUpdateGenericDocumentMutationFn = Apollo.MutationFunction<BulkUpdateGenericDocumentMutation, BulkUpdateGenericDocumentMutationVariables>;

/**
 * __useBulkUpdateGenericDocumentMutation__
 *
 * To run a mutation, you first call `useBulkUpdateGenericDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateGenericDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateGenericDocumentMutation, { data, loading, error }] = useBulkUpdateGenericDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      createEntityDocumentRelationshipInputs: // value for 'createEntityDocumentRelationshipInputs'
 *      deleteEntityDocumentRelationshipInputs: // value for 'deleteEntityDocumentRelationshipInputs'
 *   },
 * });
 */
export function useBulkUpdateGenericDocumentMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateGenericDocumentMutation, BulkUpdateGenericDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateGenericDocumentMutation, BulkUpdateGenericDocumentMutationVariables>(BulkUpdateGenericDocumentDocument, options);
      }
export type BulkUpdateGenericDocumentMutationHookResult = ReturnType<typeof useBulkUpdateGenericDocumentMutation>;
export type BulkUpdateGenericDocumentMutationResult = Apollo.MutationResult<BulkUpdateGenericDocumentMutation>;
export type BulkUpdateGenericDocumentMutationOptions = Apollo.BaseMutationOptions<BulkUpdateGenericDocumentMutation, BulkUpdateGenericDocumentMutationVariables>;